export default {
  data() {
    return {}
  },
  methods: {
    generateArrayFromOrder(order) {
      return this.generateKeyWord([
        order.patient.alias,
        order.patient.name, // + ' ' + order.patient.surname,
        order.patient.surname,
        order.primaryCode,
        order.id_mercury ? order.id_mercury : '',
        order.tempid_mercury ? order.tempid_mercury : '',
        order.company.name,
        //order.shop.name,
        order.tec,
      ])
    },
    generateKeyWord(arrayIn) {
      let arrayOut = []
      // ? Dipende se chiamiamo sempre e comunque il search
      arrayOut.push('')
      arrayIn.forEach(word => {
        if (word) {
          word = word.toLowerCase()
          for (let i = 0; i < word.length; i++) {
            let curName = ''
            let stringSequence = word.substring(i)
            stringSequence.split('').forEach(letter => {
              curName += letter
              if (curName.length > 2 && !arrayOut.find(el => el === curName)) arrayOut.push(curName)
            })
          }
        }
      })
      //console.log(arrayOut)
      return arrayOut
    },
  },
}
